import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectFontSizeOption')(function selectFontSizeOption(fontSize, state) {
    var optionState = state.optionState;
    optionState.fontSize = fontSize;
}));
//# sourceMappingURL=selectFontSizeOption.js.map